import React, {FC} from 'react';

import {Trans} from '../../../../../libs/shared/helpers/src/internationalization/react';
import {Handler} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {ChromelessButton} from '../../../../../libs/shared/ui/src/components/buttons/chromelessButton';
import {CommentComposerIcon} from './commentComposerIcon';

/*
 * Props.
 */

interface CommentComposerMentionProps {
  onMentionClick?: Handler;
  isOpen?: boolean;
  isDisabled?: boolean;
}

/*
 * Component.
 */

export const CommentComposerMention: FC<CommentComposerMentionProps> = (props) => (
  <ChromelessButton shouldPreventMouseDown isDisabled={props.isDisabled} onClick={props.onMentionClick}>
    <CommentComposerIcon
      iconName="mentionSmall"
      isDisabled={props.isDisabled}
      hasHover={props.isOpen}
      renderTooltip={() => !props.isDisabled && <Trans id="comment-composer-mention">Mention teammate</Trans>}
    />
  </ChromelessButton>
);
